export const ROLE_ADMIN = 'ADMIN';
export const ROLE_MANAGER = 'JEFE_COMERCIAL';
export const ROLE_BUYER = 'COMPRADOR';
export const ROLE_OWNER = 'DUEÑO';